import { CustomDropdownProps } from '../../interfaces';
import { CustomDropdownWrapper } from './styles';
import classNames from 'classnames';
import './styles.scss';
import { FC } from 'react';

const CustomDropdown: FC<CustomDropdownProps> = props => {
  const {
    className,
    placement = 'bottomRight',
    trigger = ['click'],
    menu,
    ...rest
  } = props;

  const items = menu?.items;
  if (!items?.length) return null;

  return (
    <CustomDropdownWrapper
      {...rest}
      menu={menu}
      trigger={trigger}
      placement={placement}
      overlayClassName="custom-dropdown-overlay"
      className={classNames(className, 'custom-dropdown')}
    />
  );
};

export default CustomDropdown;
